
// src/reducers/notifications-reducer.js

import { mergeArray, deleteArray } from '../helpers/store'

import { 
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_REQUESTED,
  FETCH_NOTIFICATIONS_COMPLETED,
  FETCH_NOTIFICATIONS_FAILED,
  FETCH_NOTIFICATIONS_UNREAD_COUNT,
  FETCH_NOTIFICATIONS_UNREAD_COUNT_REQUESTED,
  FETCH_NOTIFICATIONS_UNREAD_COUNT_COMPLETED,
  FETCH_NOTIFICATIONS_UNREAD_COUNT_FAILED,
  FLUSH_UNREAD_NOTIFICATIONS,
  FLUSH_UNREAD_NOTIFICATIONS_REQUESTED,
  FLUSH_UNREAD_NOTIFICATIONS_COMPLETED,
  FLUSH_UNREAD_NOTIFICATIONS_FAILED,
  CLEAR_NOTIFICATIONS,
  LOAD_NOTIFICATION_UNREAD_COUNT,
  UPDATE_NOTIFICATION_STATUS_COMPLETED,
} from '../actions/notifications'

import { 
  FETCH_HOME_NOTIFICATIONS,
  FETCH_HOME_NOTIFICATIONS_REQUESTED,
  FETCH_HOME_NOTIFICATIONS_COMPLETED,
  FETCH_HOME_NOTIFICATIONS_FAILED,
  FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT,
  FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT_REQUESTED,
  FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT_COMPLETED,
  FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT_FAILED,
  FLUSH_UNREAD_HOME_NOTIFICATIONS,
  FLUSH_UNREAD_HOME_NOTIFICATIONS_REQUESTED,
  FLUSH_UNREAD_HOME_NOTIFICATIONS_COMPLETED,
  FLUSH_UNREAD_HOME_NOTIFICATIONS_FAILED,
  CLEAR_HOME_NOTIFICATIONS,
  LOAD_HOME_NOTIFICATION_UNREAD_COUNT,
} from '../actions/home-notifications'
import { UPDATE_NOTIFICATION_SETTINGS_COMPLETED } from '../actions/user';

const initialState = {
  isRequesting: false,
  groups: {},
  unreadCount: {},
}

function updateGroup(groups, group_id, group) {
  let _group = Object.assign({}, groups[group_id], group)
  return Object.assign({}, groups, { [group_id]: _group })
}

export default function notificationsReducer(state = initialState, action = {}) {
  switch(action.type) {
  case FETCH_NOTIFICATIONS_REQUESTED:
  case FETCH_HOME_NOTIFICATIONS_REQUESTED:
    return Object.assign({}, state, {
      groups: updateGroup(state.groups, action.group_id, {
        isFetching: true,
        isFetchFailed: false,
      })
    })

  case FETCH_NOTIFICATIONS_UNREAD_COUNT_REQUESTED:
  case FLUSH_UNREAD_NOTIFICATIONS_REQUESTED:
  case FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT_REQUESTED:
  case FLUSH_UNREAD_HOME_NOTIFICATIONS_REQUESTED:
    return Object.assign({}, state, {
      isRequesting: true,
    })

  case FETCH_NOTIFICATIONS_FAILED:
  case FETCH_HOME_NOTIFICATIONS_FAILED:
    return Object.assign({}, state, {
      groups: updateGroup(state.groups, action.group_id, {
        isFetching: false,
        isFetchFailed: true,
      })
    })

  case FETCH_NOTIFICATIONS_UNREAD_COUNT_FAILED:
  case FLUSH_UNREAD_NOTIFICATIONS_FAILED:
  case FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT_FAILED:
  case FLUSH_UNREAD_HOME_NOTIFICATIONS_FAILED:
    return Object.assign({}, state, {
      isRequesting: false,
    })

  case FETCH_NOTIFICATIONS_COMPLETED:
  case FETCH_HOME_NOTIFICATIONS_COMPLETED:
    return Object.assign({}, state, {
      groups: updateGroup(state.groups, action.group_id, {
        isFetching: false,
        isFetchFailed: false,
        items: action.offset > 0 && state.groups[action.group_id] ? mergeArray('notification_id', state.groups[action.group_id].items, action.results) : action.results,
        hasMore: action.results.length == 10
      })
    })

  case FETCH_NOTIFICATIONS_UNREAD_COUNT_COMPLETED:
  case FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT_COMPLETED:
    return Object.assign({}, state, {
      isRequesting: false,
      unreadCount: Object.assign({}, state.unreadCount, { [action.group_id]: action.results.count })
    })

  case LOAD_HOME_NOTIFICATION_UNREAD_COUNT:
  case LOAD_NOTIFICATION_UNREAD_COUNT:
    if (!state.unreadCount || state.unreadCount[action.group_id] != action.count)
      return Object.assign({}, state, {
        unreadCount: Object.assign({}, state.unreadCount, { [action.group_id]: action.count })
      })
    else
      return state

  case FLUSH_UNREAD_NOTIFICATIONS_COMPLETED:
  case FLUSH_UNREAD_HOME_NOTIFICATIONS_COMPLETED:
    return Object.assign({}, state, {
      isRequesting: false,
      unreadCount: !state.unreadCount || state.unreadCount[action.group_id] != action.results.count ?
        Object.assign({}, state.unreadCount, { [action.group_id]: action.results.count }) : state.unreadCount
    })

  case UPDATE_NOTIFICATION_STATUS_COMPLETED:
    let groups = state.groups[action.results.group_id] ? updateGroup(state.groups, action.results.group_id, {
      items: mergeArray('notification_id', state.groups[action.results.group_id].items, [action.results], 'discard')
    }) : state.groups
    if (state.groups.home && state.groups.home.items)
      groups = updateGroup(groups, 'home', {
        items: mergeArray('notification_id', state.groups.home.items, [action.results], 'discard')
      })
    return Object.assign({}, state, { groups })

  case CLEAR_NOTIFICATIONS:
    return initialState

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/notifications-reducer.js